// extracted by mini-css-extract-plugin
export default {"details":"ZryuH","meta":"nzm2s","meta__item_key":"UWM9c","meta__item_value":"d4q1X","hr":"HXL7F","markup_el":"Gb9K6"};